"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _getWebshellclientLocale = _interopRequireDefault(require("../../../../utils/get-webshellclient-locale"));
var _makeQueryKey = _interopRequireDefault(require("../../../../utils/make-query-key"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var getPartnerCartReviewsQueryKey = function getPartnerCartReviewsQueryKey() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      isPromosUpdating: false
    },
    isPromosUpdating = _ref.isPromosUpdating;
  var country = (0, _getWebshellclientLocale["default"])().country;
  return (0, _makeQueryKey["default"])(['buy/partner_cart_reviews/v2', {
    country: country,
    isPromosUpdating: isPromosUpdating
  }]);
};
var _default = exports["default"] = getPartnerCartReviewsQueryKey;